import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SignUpData } from 'Interfaces/Auth';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: SignUpData) =>
    $actions.user.signUp(dispatch, { values }),
  );
};
